/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const resolveChatIdentitiesBodyActorUuidsMax = 100;

export const ResolveChatIdentitiesBody = zod.object({
  actorUuids: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .min(1)
    .max(resolveChatIdentitiesBodyActorUuidsMax)
    .describe(
      'OE actor uuids (USER or GROUP) to resolve to Reach user ids. Visibility-gated: self, group-mates in groups where the caller holds view-group-members, and groups where the caller holds a group-admin capability.',
    ),
});

export type ResolveChatIdentitiesBody = zod.input<typeof ResolveChatIdentitiesBody>;
export type ResolveChatIdentitiesBodyOutput = zod.output<typeof ResolveChatIdentitiesBody>;
